import { omit } from 'lodash-es';
import aegisLog from '@/log/aegis';
import { buriedBtnPoint } from '@home/utils/buriedPoint';
import { dbhBtnLogMes } from '@home/utils/buriedPointCfg';

type IAISearchButtonType = 'ai_agent' | 'ai_navigation' | 'game' | 'recent';

interface IIntelligencePageAIAccessLogParams {
  success: boolean;
  keyword: string;
  agent_res: IRecord | null;
  intelligence_page_path: string;
  intelligence_page_query: IRecord;
}

const buildAISearchButtonExtInfo = (params: { aiSearchType: IAISearchButtonType; data: any }) => {
  return JSON.stringify({
    ai_search_type: params.aiSearchType,
    data: params.data,
  });
};

export const logAISearchButtonClick = (params: { aiSearchType: IAISearchButtonType; data: any }) => {
  const btnLogCfg = dbhBtnLogMes.intelligencePageAIAccess;

  try {
    buriedBtnPoint({
      ...btnLogCfg,
      extInfo: buildAISearchButtonExtInfo(params),
    });
  } catch (error) {
    console.error(error);
  }
};

const logDataBrain = (params: IIntelligencePageAIAccessLogParams) => {
  logAISearchButtonClick({
    aiSearchType: 'ai_navigation',
    data: {
      success: params?.success || false,
      keyword: params?.keyword || '',
      agent_res: params?.agent_res || {},
      intelligence_page_path: params?.intelligence_page_path || '',
      intelligence_page_query: params?.intelligence_page_query || {},
    },
  });
};

const logAegis = (params: IIntelligencePageAIAccessLogParams) => {
  if (!!params?.success) {
    return;
  }

  try {
    aegisLog.reportEvent({
      name: 'dbi_page_ai_access_failed',
      msg: '首页智能搜索 跳转到情报页面失败',
      ext1: params?.keyword || '',
      ext2: JSON.stringify(omit(params, ['success', 'keyword'])),
      // ext3: '',
    });
  } catch (error) {
    console.error(error);
  }
};

/**
 * 打点
 * @param params - 打点参数
 */
export const logIntelligencePageAIAccess = (params: {
  success: boolean;
  keyword: string;
  agent_res: IRecord | null;
  intelligence_page_path: string;
  intelligence_page_query: IRecord;
}) => {
  // 打点到databrain
  logDataBrain(params);
  // 上报aegis
  logAegis(params);
};
